// extracted by mini-css-extract-plugin
export default {"card":"InfoBanner_card__K402m","container":"InfoBanner_container__UA8oE","content":"InfoBanner_content__AmsXV"};